import React from 'react';
import Tabs from '@mui/material/Tabs';
import {useParams} from 'react-router-dom';

import EarnTab from './EarnTab';
import './EarnTabsNavigation.scss';

export const EarnTabValue = {
    NXUSD_USDC_LP_Staking: 'nxusd-usdc-lp',
    NRS_USDC_LP_Staking: 'nrs-usdc-lp',
    NRS_Locking: 'nrs-locking',
}

export function useCurrentEarnTab() {
    const {  tab: routeTab } = useParams();
    return routeTab || EarnTabValue.NXUSD_USDC_LP_Staking
}

const EarnTabsNavigation = () => {

    const currentTab = useCurrentEarnTab()

    return (
        <div className="EarnTabsNavigation">
            <Tabs value={currentTab}
                  // variant="scrollable"
                  // scrollButtons
                  // allowScrollButtonsMobile
                  TabIndicatorProps={{
                style: {
                    display: 'none'
                }

            }}>
                <EarnTab label="NXUSD USDC LP Staking" to={`/earn`} value={EarnTabValue.NXUSD_USDC_LP_Staking} />
                <EarnTab label="NRS USDC LP Staking" to={`/earn/${EarnTabValue.NRS_USDC_LP_Staking}`} value={EarnTabValue.NRS_USDC_LP_Staking} />
                <EarnTab label="NRS Locking" to={`/earn/${EarnTabValue.NRS_Locking}`} value={EarnTabValue.NRS_Locking} />
            </Tabs>
        </div>
    );
};

export default EarnTabsNavigation;